import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import WrapperProvider from "./modules/WrapperProvider";
import "best-common-react/lib/styles/bcr.css";
import "best-common-react-3/lib/styles/bcr.css";
import "best-common-react/lib/styles/bcr.css";
import "./assets/fonts/static/WorkSans-Italic.ttf";
import "./assets/fonts/static/WorkSans-LightItalic.ttf";
import "./assets/fonts/static/WorkSans-Medium.ttf";
import "./assets/fonts/static/WorkSans-MediumItalic.ttf";
import "./assets/fonts/static/WorkSans-Regular.ttf";
import "./assets/fonts/static/WorkSans-SemiBold.ttf";
import "./assets/fonts/static/WorkSans-SemiBoldItalic.ttf";
import "./assets/fonts/WorkSans-VariableFont_wght.ttf";
import { datadogRum } from "@datadog/browser-rum";

const container = document.getElementById("bedroc-ui");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

if (window.MLBBest.envVariables.APP_ENV !== "local") {
  datadogRum.init({
    applicationId: window.MLBBest.envVariables.DATADOG_APP_ID,
    clientToken: window.MLBBest.envVariables.DATADOG_CLIENT_TOKEN,
    site: "us5.datadoghq.com",
    service: "best-bedroc",
    env: window.MLBBest.envVariables.APP_ENV,
    sampleRate: 100,
    premiumSampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  });

  datadogRum.startSessionReplayRecording();
}

root.render(
  <WrapperProvider>
    <App />
  </WrapperProvider>,
);
